import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightningBolt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"lightning-bolt, speed, thunder, flash, high woltage"} maskId="square-filled-radius-0-stroke-1-IconLightningBolt"><path d="M13.5771 10H19.041L9.24707 22.2432L10.4248 14H4.96094L14.7549 1.75684L13.5771 10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLightningBolt;
